import classnames from 'classnames';
import React from 'react';
const TypographyText = props => {
  const {
    type = 'inherit',
    size = 'inherit',
    strong = false,
    deleted = false,
    italic = false,
    underline = false,
    inline,
    children,
    onClick,
    onMouseDown,
    onMouseUp,
    prefixClass = 'zen-design',
    //TODO 写provider时统一改掉
    className,
    style,
    ...restProps
  } = props;
  const baseClassName = "".concat(prefixClass, "-typography-text");
  return /*#__PURE__*/React.createElement(inline ? 'span' : 'div', {
    ...restProps,
    onClick,
    onMouseDown,
    onMouseUp,
    className: classnames(baseClassName, "size-".concat(size), "type-".concat(type), {
      strong,
      deleted,
      italic,
      underline,
      clickable: !!onClick || !!onMouseDown || !!onMouseUp
    }, className),
    style
  }, children);
};
export default TypographyText;